/**
 * Two variants. Secondary is the default (most buttons in the app).
 * Primary is reserved for the single most important action on a page.
 */
const BASE =
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-bg-base disabled:cursor-not-allowed disabled:opacity-50';

const VARIANTS = {
  primary:
    'bg-brand text-[#1A0E04] hover:brightness-105 active:brightness-95 px-4 py-2',
  secondary:
    'bg-transparent border border-border-strong text-text-body hover:bg-bg-card px-4 py-2',
  ghost:
    'bg-transparent text-text-body hover:bg-bg-card px-3 py-1.5',
};

export const Button = ({ variant = 'secondary', class: className = '', children, ...rest }) => (
  <button class={`${BASE} ${VARIANTS[variant]} ${className}`} {...rest}>
    {children}
  </button>
);
